var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRejected = function SvgRejected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8097 19.7935C14.5562 23.8642 7.65947 23.8642 3.40607 19.7935C2.86464 19.2754 2.86464 18.4354 3.40607 17.9177C3.9475 17.3995 4.82519 17.3995 5.36662 17.9177C8.53756 20.9518 13.6786 20.9518 16.8495 17.9177C20.02 14.8832 20.02 9.96339 16.8495 6.92888C13.6786 3.89476 8.53756 3.89476 5.36662 6.92888C4.82519 7.44702 3.9475 7.44702 3.40607 6.92888C2.86464 6.41113 2.86464 5.57083 3.40607 5.05307C7.65947 0.982309 14.5562 0.982309 18.8097 5.05307C23.0634 9.12346 23.0634 15.7231 18.8097 19.7935ZM14.2706 17.1844L11.2076 14.1214L12.62 12.709L15.6831 15.772L14.2706 17.1844ZM12.62 12.709L10.9918 11.0807L13.8174 8.25513L15.4456 9.88338L12.62 12.709ZM9.57935 12.4932L11.2076 14.1214L8.38337 16.9456L6.75513 15.3174L9.57935 12.4932ZM9.57935 12.4932L10.9918 11.0807L8.10715 8.19607L6.6947 9.60852L9.57935 12.4932Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRejected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rejected.b1743f80.svg";
export { ForwardRef as ReactComponent };